export enum FecImportAnalysisErrorCode {
  DetectionFailed = 'detection_failed',
  InvalidEncoding = 'invalid_encoding',
  MissingColumns = 'missing_columns',
  ParsingFailed = 'parsing_failed',
  Timeout = 'timeout',
}
